import DgoContainer from "@/components/DGOContainer/DGOContainer.vue";
import DgoRow from "@/components/DGORow/DGORow.vue";
import DgoCol from "@/components/DGOCol/DGOCol.vue";
import NntPopup from "@/components/NNTPopup/NNTPopup.vue";
import Autenticacao from "@/views//Templates/Autenticacao/Autenticacao.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate/dist/vee-validate.full.esm";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { arrHasAnyEqualVal } from "@/helpers/helpers";

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        Autenticacao,
        DgoContainer,
        NntPopup,
        DgoRow,
        DgoCol,
    },
    data: ()=> ({
        form: {
            email: '',
            password: '',
        }
    }),
    computed: {
        ...mapGetters('token', ['tokenAccess']),
        ...mapState('token', {
            tokens: 'tokens',
            loadingToken: 'token',
            successToken: 'success',
            errorToken: 'error',
        }),
    },
    watch: {
        tokenAccess(newVal) { if (newVal) { this.$router.push('/arquivos'); } },
    },
    methods: {
        ...mapActions('token', ['requestToken']),
        ...mapMutations('token', ['setCredentials']),
        async onSubmit() {
            this.setCredentials(this.form);
            const token = await this.requestToken();
            
            if (token) {
                if (this.$route.query.hasOwnProperty('unsubscribe')) {
                    this.$router.push('/perfil');
                } else {
                    this.$router.push('/arquivos');
                }
            } else {
                const hasFieldsError = arrHasAnyEqualVal(this.form, this.errorToken);
                if (hasFieldsError) { this.$refs.form.setErrors(this.errorToken); }
            }
        }
    },
}
